export const TransferDecisionVI = {
    "decisionTransfer":{
        "title": {
            "add": "Tạo mới quyết định điều chuyển",
            "update": "Cập nhật quyết định điều chuyển",
            "detail": "Chi tiết quyết định điều chuyển"
        },
    }
}